interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const styles: Record<string, string> = {
    pending: 'bg-amber-100 dark:bg-amber-500/15 text-amber-700 dark:text-amber-200 border-amber-300 dark:border-amber-500/30',
    completed: 'bg-emerald-100 dark:bg-emerald-500/15 text-emerald-700 dark:text-emerald-200 border-emerald-300 dark:border-emerald-500/30',
    skipped: 'bg-slate-100 dark:bg-slate-500/15 text-slate-700 dark:text-slate-200 border-slate-300 dark:border-slate-500/30',
    in_progress: 'bg-primary-100 dark:bg-primary-500/15 text-primary-700 dark:text-primary-200 border-primary-300 dark:border-primary-500/30',
    not_started: 'bg-gray-100 dark:bg-gray-500/15 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-500/30',
    scheduled: 'bg-cyan-100 dark:bg-cyan-500/15 text-cyan-700 dark:text-cyan-200 border-cyan-300 dark:border-cyan-500/30',
  };

  return (
    <span
      className={`text-xs px-3 py-1 rounded-full border capitalize shrink-0 ${
        styles[status] || styles.pending
      }`}
    >
      {status.replace('_', ' ')}
    </span>
  );
}
